// extracted by mini-css-extract-plugin
export default {"varInfo":"VarItem_varInfo__k4acd","varNumber":"VarItem_varNumber__MBQCt","varTitle":"VarItem_varTitle__Gl0Yf"};